(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    (() => {
    const storageKey = 'email-signup-submitted-instance';
    const blockSelector = '.email-signup-block[data-email-signup-instance]';

    const rememberSubmittedInstance = (form) => {
      const block = form.closest(blockSelector);
      if (!block) return;

      try {
        sessionStorage.setItem(storageKey, block.dataset.emailSignupInstance);
      } catch (error) {
        // Ignore storage restrictions; Shopify submission still works normally.
      }
    };

    const revealSubmittedMessage = () => {
      let submittedInstance = null;

      try {
        submittedInstance = sessionStorage.getItem(storageKey);
      } catch (error) {
        return;
      }

      if (!submittedInstance) return;

      let matched = false;

      document.querySelectorAll(blockSelector).forEach((block) => {
        const success = block.querySelector('.email-signup__message--success');
        const error = block.querySelector('.email-signup__message--error');

        if (block.dataset.emailSignupInstance !== submittedInstance) {
          if (success) success.hidden = true;
          if (error) error.hidden = true;
          return;
        }

        const message = error || success;
        if (!message) return;

        message.hidden = false;
        matched = true;

        const input = block.querySelector('.email-signup__input');
        if (input) {
          if (error) {
            input.setAttribute('aria-invalid', 'true');
            input.setAttribute('aria-describedby', error.id);
          } else {
            input.removeAttribute('aria-invalid');
            input.setAttribute('aria-describedby', success.id);
          }
        }
      });

      if (matched) {
        try {
          sessionStorage.removeItem(storageKey);
        } catch (error) {
          // No action needed.
        }
      }
    };

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('.email-signup__form');
      if (form) rememberSubmittedInstance(form);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', revealSubmittedMessage, { once: true });
    } else {
      revealSubmittedMessage();
    }

    document.addEventListener('shopify:section:load', revealSubmittedMessage);
  })();
  } catch(e) { console.error(e); }
})();

})();
